import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

import toast from 'react-hot-toast';
import '../QuickActions.scss';

const ClientPortal = ({ newShow, handleNewClose, onSubmit }) => {
	const [email, setEmail] = useState('');

	const [isDisabled, setIsDisabled] = useState(false);



	const handleSubmit = (e) => {
		e.preventDefault();
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

		if (!(email?.length > 0) || !emailRegex.test(email)) {
			toast.error('Please enter a valid email');
			return;
		} else {
			const data = {
				email: email
			};
			setIsDisabled(true);

			toast.promise(api.sendClientLink(data), {
				loading: 'Sending...',
				success: (res) => {
					if (res?.status) {
						setIsDisabled(false);
						handleNewClose();
					}
					return res?.status ? 'Client link sent successfully' : 'Failed to send email';
				},
				error: (err) => `Failed to send email: ${err.message}`
			});
		}
	};

	return (
		<Modal show={newShow} onHide={handleNewClose} centered size="sm">
			<div className="p-4">
				<Modal.Title
					className="text-center mx-auto cstm-prtl-titl"
					style={{ marginBottom: 15, marginTop: 10, fontWeight: 500, fontFamily: 'poppins', fontSize: 16 }}
				>
					New user portal
				</Modal.Title>
				<form onSubmit={handleSubmit} className="userForm">
					<div className="row">
						<div className="col-12 p-2 refer-link">
							<input
								type="email"
								name=""
								id=""
								placeholder="Enter client email"
								onChange={(e) => {
									setEmail(e.target.value);
								}}
								className="form-control"
								style={{ width: '75%', textAlign: 'center', fontFamily: 'poppins' }}
							/>
						</div>
						<div className="col-12 d-flex justify-content-center">
							<button
								style={{ marginTop: 20, marginBottom: 10, fontFamily: 'poppins' }}
								type="submit"
								className="btn btn-cmpny-dtls-action"
								disabled={isDisabled}
							>
								Send
							</button>
						</div>
					</div>
				</form>
			</div>
		</Modal>
	);
};

export default ClientPortal;
